/**
 * Elementary School Missing Words - Supplement
 * 小学缺失单词补充
 */

import { VocabularyWord } from './vocabulary';

export const elementaryMissingWords: VocabularyWord[] = [
  // 地点和建筑 - 小学3-5年级
  {
    id: 'bank',
    word: 'bank',
    phonetic: '/bæŋk/',
    phoneticUS: '/bæŋk/',
    phoneticUK: '/bæŋk/',
    meaning: '银行',
    example: 'My father works in a bank.',
    exampleTranslation: '我爸爸在银行工作。',
    category: 'places',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🏦'
  },
  {
    id: 'hospital',
    word: 'hospital',
    phonetic: '/ˈhɑspɪtl/',
    phoneticUS: '/ˈhɑspɪtl/',
    phoneticUK: '/ˈhɒspɪtl/',
    meaning: '医院',
    example: 'My mother is a doctor in the hospital.',
    exampleTranslation: '我妈妈是医院的医生。',
    category: 'places',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '🏥'
  },
  {
    id: 'post-office',
    word: 'post office',
    phonetic: '/ˈpoʊst ˈɔfɪs/',
    phoneticUS: '/ˈpoʊst ˈɔfɪs/',
    phoneticUK: '/ˈpəʊst ˈɒfɪs/',
    meaning: '邮局',
    example: 'I went to the post office yesterday.',
    exampleTranslation: '我昨天去了邮局。',
    category: 'places',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '📮'
  },
  {
    id: 'supermarket',
    word: 'supermarket',
    phonetic: '/ˈsuːpərˌmɑrkɪt/',
    phoneticUS: '/ˈsuːpərˌmɑrkɪt/',
    phoneticUK: '/ˈsuːpəˌmɑːkɪt/',
    meaning: '超市',
    example: 'We buy food at the supermarket.',
    exampleTranslation: '我们在超市买食物。',
    category: 'places',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🏪'
  },
  {
    id: 'library',
    word: 'library',
    phonetic: '/ˈlaɪbreri/',
    phoneticUS: '/ˈlaɪbreri/',
    phoneticUK: '/ˈlaɪbrəri/',
    meaning: '图书馆',
    example: 'I read books in the library.',
    exampleTranslation: '我在图书馆看书。',
    category: 'places',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    image: '📚'
  },
  {
    id: 'park',
    word: 'park',
    phonetic: '/pɑrk/',
    phoneticUS: '/pɑrk/',
    phoneticUK: '/pɑːk/',
    meaning: '公园',
    example: 'We play in the park.',
    exampleTranslation: '我们在公园玩。',
    category: 'places',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🌳'
  },
  {
    id: 'restaurant',
    word: 'restaurant',
    phonetic: '/ˈrestərɑnt/',
    phoneticUS: '/ˈrestərɑnt/',
    phoneticUK: '/ˈrestrɒnt/',
    meaning: '餐馆',
    example: 'We had dinner at a restaurant.',
    exampleTranslation: '我们在餐馆吃了晚餐。',
    category: 'places',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🍽️'
  },
  {
    id: 'cinema',
    word: 'cinema',
    phonetic: '/ˈsɪnəmə/',
    phoneticUS: '/ˈsɪnəmə/',
    phoneticUK: '/ˈsɪnəmə/',
    meaning: '电影院',
    example: 'Let us go to the cinema.',
    exampleTranslation: '我们去电影院吧。',
    category: 'places',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    image: '🎬'
  },

  // 日常用品 - 小学3-4年级
  {
    id: 'bag',
    word: 'bag',
    phonetic: '/bæɡ/',
    phoneticUS: '/bæɡ/',
    phoneticUK: '/bæɡ/',
    meaning: '包；袋子',
    example: 'This is my school bag.',
    exampleTranslation: '这是我的书包。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🎒'
  },
  {
    id: 'book',
    word: 'book',
    phonetic: '/bʊk/',
    phoneticUS: '/bʊk/',
    phoneticUK: '/bʊk/',
    meaning: '书',
    example: 'I have many books.',
    exampleTranslation: '我有很多书。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '📖'
  },
  {
    id: 'pen',
    word: 'pen',
    phonetic: '/pen/',
    phoneticUS: '/pen/',
    phoneticUK: '/pen/',
    meaning: '钢笔',
    example: 'This is my pen.',
    exampleTranslation: '这是我的钢笔。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🖊️'
  },
  {
    id: 'pencil',
    word: 'pencil',
    phonetic: '/ˈpensl/',
    phoneticUS: '/ˈpensl/',
    phoneticUK: '/ˈpensl/',
    meaning: '铅笔',
    example: 'I write with a pencil.',
    exampleTranslation: '我用铅笔写字。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '✏️'
  },
  {
    id: 'ruler',
    word: 'ruler',
    phonetic: '/ˈruːlər/',
    phoneticUS: '/ˈruːlər/',
    phoneticUK: '/ˈruːlə/',
    meaning: '尺子',
    example: 'I have a ruler.',
    exampleTranslation: '我有一把尺子。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '📏'
  },
  {
    id: 'eraser',
    word: 'eraser',
    phonetic: '/ɪˈreɪsər/',
    phoneticUS: '/ɪˈreɪsər/',
    phoneticUK: '/ɪˈreɪzə/',
    meaning: '橡皮',
    example: 'I use an eraser.',
    exampleTranslation: '我用橡皮。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🧽'
  },

  // 身体部位补充 - 小学3年级
  {
    id: 'head',
    word: 'head',
    phonetic: '/hed/',
    phoneticUS: '/hed/',
    phoneticUK: '/hed/',
    meaning: '头',
    example: 'I have one head.',
    exampleTranslation: '我有一个头。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '👤'
  },
  {
    id: 'face',
    word: 'face',
    phonetic: '/feɪs/',
    phoneticUS: '/feɪs/',
    phoneticUK: '/feɪs/',
    meaning: '脸',
    example: 'Wash your face.',
    exampleTranslation: '洗你的脸。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '😊'
  },
  {
    id: 'ear',
    word: 'ear',
    phonetic: '/ɪr/',
    phoneticUS: '/ɪr/',
    phoneticUK: '/ɪə/',
    meaning: '耳朵',
    example: 'I have two ears.',
    exampleTranslation: '我有两只耳朵。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '👂'
  },
  {
    id: 'eye',
    word: 'eye',
    phonetic: '/aɪ/',
    phoneticUS: '/aɪ/',
    phoneticUK: '/aɪ/',
    meaning: '眼睛',
    example: 'I have two eyes.',
    exampleTranslation: '我有两只眼睛。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '👁️'
  },
  {
    id: 'nose',
    word: 'nose',
    phonetic: '/noʊz/',
    phoneticUS: '/noʊz/',
    phoneticUK: '/nəʊz/',
    meaning: '鼻子',
    example: 'I have one nose.',
    exampleTranslation: '我有一个鼻子。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '👃'
  },
  {
    id: 'mouth',
    word: 'mouth',
    phonetic: '/maʊθ/',
    phoneticUS: '/maʊθ/',
    phoneticUK: '/maʊθ/',
    meaning: '嘴巴',
    example: 'Open your mouth.',
    exampleTranslation: '张开嘴巴。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '👄'
  },
  {
    id: 'arm',
    word: 'arm',
    phonetic: '/ɑrm/',
    phoneticUS: '/ɑrm/',
    phoneticUK: '/ɑːm/',
    meaning: '手臂',
    example: 'I have two arms.',
    exampleTranslation: '我有两只手臂。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '💪'
  },
  {
    id: 'leg',
    word: 'leg',
    phonetic: '/leɡ/',
    phoneticUS: '/leɡ/',
    phoneticUK: '/leɡ/',
    meaning: '腿',
    example: 'I have two legs.',
    exampleTranslation: '我有两条腿。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🦵'
  },
  {
    id: 'foot',
    word: 'foot',
    phonetic: '/fʊt/',
    phoneticUS: '/fʊt/',
    phoneticUK: '/fʊt/',
    meaning: '脚',
    example: 'I have two feet.',
    exampleTranslation: '我有两只脚。',
    category: 'body',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🦶'
  },

  // 食物补充 - 小学3年级
  {
    id: 'chicken',
    word: 'chicken',
    phonetic: '/ˈtʃɪkɪn/',
    phoneticUS: '/ˈtʃɪkɪn/',
    phoneticUK: '/ˈtʃɪkɪn/',
    meaning: '鸡肉；鸡',
    example: 'I like chicken.',
    exampleTranslation: '我喜欢吃鸡肉。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🍗'
  },
  {
    id: 'fish-food',
    word: 'fish',
    phonetic: '/fɪʃ/',
    phoneticUS: '/fɪʃ/',
    phoneticUK: '/fɪʃ/',
    meaning: '鱼；鱼肉',
    example: 'I like eating fish.',
    exampleTranslation: '我喜欢吃鱼。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐟'
  },
  {
    id: 'vegetable',
    word: 'vegetable',
    phonetic: '/ˈvedʒtəbl/',
    phoneticUS: '/ˈvedʒtəbl/',
    phoneticUK: '/ˈvedʒtəbl/',
    meaning: '蔬菜',
    example: 'I eat vegetables every day.',
    exampleTranslation: '我每天都吃蔬菜。',
    category: 'food',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    image: '🥬'
  },
  {
    id: 'fruit',
    word: 'fruit',
    phonetic: '/fruːt/',
    phoneticUS: '/fruːt/',
    phoneticUK: '/fruːt/',
    meaning: '水果',
    example: 'I like fruit.',
    exampleTranslation: '我喜欢水果。',
    category: 'food',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🍎'
  },

  // 动物补充 - 小学3年级
  {
    id: 'monkey',
    word: 'monkey',
    phonetic: '/ˈmʌŋki/',
    phoneticUS: '/ˈmʌŋki/',
    phoneticUK: '/ˈmʌŋki/',
    meaning: '猴子',
    example: 'The monkey is funny.',
    exampleTranslation: '猴子很滑稽。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐒'
  },
  {
    id: 'elephant',
    word: 'elephant',
    phonetic: '/ˈelɪfənt/',
    phoneticUS: '/ˈelɪfənt/',
    phoneticUK: '/ˈelɪfənt/',
    meaning: '大象',
    example: 'The elephant is big.',
    exampleTranslation: '大象很大。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐘'
  },
  {
    id: 'lion',
    word: 'lion',
    phonetic: '/ˈlaɪən/',
    phoneticUS: '/ˈlaɪən/',
    phoneticUK: '/ˈlaɪən/',
    meaning: '狮子',
    example: 'The lion is the king.',
    exampleTranslation: '狮子是国王。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🦁'
  },
  {
    id: 'tiger',
    word: 'tiger',
    phonetic: '/ˈtaɪɡər/',
    phoneticUS: '/ˈtaɪɡər/',
    phoneticUK: '/ˈtaɪɡə/',
    meaning: '老虎',
    example: 'The tiger is strong.',
    exampleTranslation: '老虎很强壮。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐯'
  },
  {
    id: 'bear',
    word: 'bear',
    phonetic: '/ber/',
    phoneticUS: '/ber/',
    phoneticUK: '/beə/',
    meaning: '熊',
    example: 'The bear is sleeping.',
    exampleTranslation: '熊在睡觉。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐻'
  },
  {
    id: 'sheep',
    word: 'sheep',
    phonetic: '/ʃiːp/',
    phoneticUS: '/ʃiːp/',
    phoneticUK: '/ʃiːp/',
    meaning: '绵羊',
    example: 'The sheep is white.',
    exampleTranslation: '绵羊是白色的。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐑'
  },
  {
    id: 'horse',
    word: 'horse',
    phonetic: '/hɔrs/',
    phoneticUS: '/hɔrs/',
    phoneticUK: '/hɔːs/',
    meaning: '马',
    example: 'The horse runs fast.',
    exampleTranslation: '马跑得很快。',
    category: 'animals',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    image: '🐴'
  },
];

export default elementaryMissingWords;
